import React from "react";
export default class Projectgroup extends React.Component {
	constructor(props) {
		super(props);
		const {
			step,
			groups,
			type
		} = props.project;
		this.state = {
			ncdata: [],
			ptdata: [],
			groups: groups,
			step: step,
			service_type: type
		}
	}

	componentWillReceiveProps(nextProps) {
		const me = this;
		const {
			step,
			groups,
			type
		} = nextProps.project;
		me.setState({
			groups: groups,
			step: step,
			service_type: type
		});
	}

	componentDidMount() {
		const {
			step,
			groups,
			type
		} = this.props.project; //VBM or TBSS
		this.setState({
			groups: groups,
			step: step,
			service_type: type
		});
	}

	showsubject(groupid) {
		const me = this;
		let groups = me.state.groups;
		groups.map((g, i) => {
			if (g.id === groupid) {
				g.showsubjects = !g.showsubjects
			}
			return g;
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups
		});
	}

	showfile(groupid, subjectid) {
		const me = this;
		let groups = me.state.groups;
		groups.map((g, i) => {
			if (g.id === groupid) {
				g.subjects.data.map((s, i) => {
					if (s.id === subjectid) {
						s.showfiles = !s.showfiles;
					}
					return s;
				});
			}
			return g;
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups
		});
		return;

	}

	control_file_checkbox(item) {
		let file_len = 0;
		if (typeof (item.task) !== 'undefined' && item.task.length) {
			item.task.map((t, n) => {
				if (t.files.length) {
					t.files.map((f, m) => {
						f.checked = item.checked;
						return f;
					});
					file_len += t.files.length;

				}
				return t;
			});
		}
		if (typeof (item.head) !== 'undefined' && item.head.length) {
			item.head.map((t, n) => {
				if (t.files.length) {
					t.files.map((f, m) => {
						f.checked = item.checked;
						return f;
					});
					file_len += t.files.length;
				}
				return t;
			});
		}
		item.checkedfile = item.checked ? file_len : 0;
	}

	checkgroup(groupid) {
		const me = this;
		let {
			groups
		} = me.state;
		groups.map(function (g, i) {
			if (g.id === groupid) {
				g.checked = !g.checked;
				if (g.subjects.size) {
					g.subjects.data.map((item, i) => {
						item.checked = g.checked;
						me.control_file_checkbox(item);
						return item;
					});
				}
				g.checkedsubject = g.checked ? g.subjects.size : 0;
			}
			return g;
		});
		groups = Object.assign(me.state.groups, groups)
		me.setState({
			groups: groups
		});
	}

	checksubject(groupid, subjectid) {
		const me = this;
		let {
			groups
		} = me.state;
		groups.map(function (g, i) {
			if (g.id === groupid && g.subjects.size) {
				g.subjects.data.map((item, i) => {
					if (item.id === subjectid) {
						item.checked = !item.checked;
						me.control_file_checkbox(item);
						g.checkedsubject = item.checked ? g.checkedsubject + 1 : g.checkedsubject - 1;
					}
					return item;
				});
				groups[i].checked = g.checkedsubject > 0;
				//groups[i].checked = (g.checkedsubject > 0) ? true : g.checked;
				//groups[i].checked = g.checkedsubject === 0 ? false : g.checked;
			}
			return g;
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups
		});
	}


	checkfile(groupid, subjectid, fileid) {
		const me = this;
		let {
			groups
		} = me.state;
		groups.map(function (g, i) {
			if (g.id === groupid && g.subjects.size) {
				g.subjects.data.map((item, i) => {
					if (item.id === subjectid) {
						let file_len = 0;
						if (typeof (item.task) !== 'undefined' && item.task.length) {
							item.task.map((t, n) => {
								if (t.files.length) {
									t.files.map((f, m) => {
										if (f.id === fileid) {
											f.checked = !f.checked;
											file_len = f.checked ? file_len + 1 : file_len - 1;
										}

										return f;
									})
								}
								return t;
							});
						}
						if (typeof (item.head) !== 'undefined' && item.head.length) {
							item.head.map((t, n) => {
								if (t.files.length) {
									t.files.map((f, m) => {
										if (f.id === fileid) {
											f.checked = !f.checked
											file_len = f.checked ? file_len + 1 : file_len - 1;
											return f;
										}
									});
								}
								return t;
							});
						}
						item.checkedfile = file_len;
						item.checked = file_len > 0;
						//me.control_file_checkbox(item);
						g.checkedsubject = item.checked ? g.checkedsubject + 1 : g.checkedsubject - 1;
					}
					return item;
				});
				groups[i].checked = g.checkedsubject > 0;
				//groups[i].checked = (g.checkedsubject > 0) ? true : g.checked;
				//groups[i].checked = g.checkedsubject === 0 ? false : g.checked;
			}
			return g;
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups
		});
	}

	render() {
		const me = this;

		let {
			groups,
			step
		} = me.state;

		//console.log(groups);
		return (
			<div className="mt-3 groups  ">
				{
					groups.length > 0 && groups.map((group, key) => {
						return (
							<div className="card_list" key={key}>

								<div className="clearfix pt-2 pl-2 pr-2">
									<div className="custom-control custom-checkbox d-inline-block">
										<input type="checkbox" className="custom-control-input" id={step + '_group_' + group.id} checked={group.checked} onChange={() => this.checkgroup(group.id)} />
										<label className="custom-control-label" htmlFor={step + '_group_' + group.id}>{group.name}</label>
									</div>
									<span className="px-2 cursor" onClick={() => this.showsubject(group.id)}>
										<i className="fa fa-caret-down  animated rubberBand"></i>
									</span>
								</div>

								<div className="">
									{group.showsubjects && group.subjects.size > 0 && group.subjects.data.map((item, i) => {

										return (
											<div className="list-group-item" key={item.id}>
												<div className="d-flex justify-content-between">
													<div style={{ minWidth: '40%', maxWidth: '50%' }}>
														<div className="custom-control custom-checkbox d-inline">
															<input type="checkbox" className="custom-control-input" id={step + '_subject_' + item.id} checked={item.checked} name={`step${step}[${item.id}][]`} onChange={() => this.checksubject(group.id, item.id)} />
															<label className="custom-control-label" htmlFor={step + '_subject_' + item.id}>{item.subject_name}</label>
														</div>
														<span className="cursor cursor_success ml-3" onClick={() => this.showfile(group.id, item.id)}>
															<small className="mr-1">
																{(() => {
																	if (item.subject_gender === '0') {
																		return ('男')
																	} else {
																		return ('女')
																	}
																})()}
															</small>

															<small className="mr-1" title="年龄">{item.subject_age}</small>

															<i className="fa fa-caret-down"></i>
														</span>
													</div>
													<div title="扫描 Series" className="text-left">
														{
															item.series.isArray && item.series.map((s, i) => {
																return (
																	<span key={i} className="badge badge-success badge-pill mr-1">{s}</span>
																)
															})
														}
													</div>
													<small title="扫描时间 Series Date">{item.series_date}</small>
												</div>
												{
													item.showfiles && typeof (item.head) !== 'undefined' && item.head !== false && item.head.length && item.head.map((t, i) => {
														return (
															<div className="border-top p-3 bg-light  animated fadeIn" key={i}>
																<div className="text-right text-muted">
																	<small>检查实例：{t.study_instance_uid} 共{t.total_files}件</small>
																</div>
																{
																	t.files.length > 0 && t.files.map((file, n) => {
																		return (
																			<div className="d-flex justify-content-between" data-servie={file[me.state.service_type]} data-filepath={file.file_path + '/' + file.archive_name + '.nii'} key={n}>
																				<div className="custom-control custom-checkbox d-inline">
																					<input type="checkbox" className="custom-control-input" id={step + '_file_' + file.id} checked={file.checked} name={`step${step}[${item.id}][${file.id}]`} onChange={() => this.checkfile(group.id, item.id, file.id)} />
																					<label className="custom-control-label" htmlFor={step + '_file_' + file.id}>{file.subject} {file.age}</label>
																				</div>
																				<small>{file.series_name}</small> <small>扫描时间：{file.series_date}</small>
																			</div>)

																	})
																}
															</div>
														)

													})
												}
											</div>
										)

									})
									}
								</div>
							</div>

						)
					})
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/project_service_group.js